import _extends from "@babel/runtime/helpers/extends";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Helmet from 'react-helmet';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { isLoaded as isAuthLoaded, load as loadAuth, logout } from 'redux/modules/auth';
import { loadWhitelabel } from 'redux/modules/config';
import MainLayout from 'containers/Layouts/MainLayout/MainLayout';
import ModalLayout from 'containers/Layouts/ModalLayout/ModalLayout';
import { push } from 'react-router-redux';
import config from 'config';
import * as styles from './App.scss';
import getTheme from '../../components/MuiTheme';
var App = (_dec = connect(function (state) {
  return {
    user: state.auth.user,
    organization: state.organization && state.organization.current ? state.organization.current : null,
    config: state.config,
    theme: state.theme
  };
}, {
  logout: logout,
  pushState: push,
  loadWhitelabel: loadWhitelabel
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(App, _Component);

  var _super2 = _createSuper(App);

  function App(props) {
    var _this2;

    _classCallCheck(this, App);

    _this2 = _super2.call(this, props);

    _defineProperty(_assertThisInitialized(_this2), "handleLogout", function (event) {
      event.preventDefault();

      _this2.props.logout();
    });

    _this2.state = {
      whiteLabelLoaded: false
    };
    return _this2;
  }

  _createClass(App, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // manage overlay content
      if (nextProps.location.key !== this.props.location.key && nextProps.location.state && nextProps.location.state.modal) {
        // save the old children to show up behind overlay
        this.previousChildren = this.props.children;
      }

      if (!this.props.user && nextProps.user && nextProps.user.Organizations && nextProps.user.Organizations.filter(function (o) {
        return o.status !== 'pending';
      }).length > 0) {
        console.log('proceed to schedule page');
        this.props.pushState("/org/".concat(nextProps.user.Organizations[0].id, "/publishing"));
      } else if (this.props.user && !nextProps.user) {
        console.log('require login');
        this.props.pushState('/login');
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevState.whiteLabelLoaded && this.props.user && this.props.theme) {
        this.setState({
          whiteLabelLoaded: true
        });
        this.props.loadWhitelabel(this.props.theme.org)["catch"](function (err) {
          return console.error(err);
        });
      }
    }
  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      if (this.props.user && this.props.theme) {
        this.setState({
          whiteLabelLoaded: true
        });
        this.props.loadWhitelabel(this.props.theme.org)["catch"](function (err) {
          return console.error(err);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          user = _this$props.user,
          children = _this$props.children,
          location = _this$props.location;
      var isModal = location.state && location.state.modal && this.previousChildren;
      {
        /* Cloning here allows passing thru props to all child containers */
      }
      var clonedChildren = children ? /*#__PURE__*/React.cloneElement(children, {
        user: user,
        key: location.pathname,
        isModal: isModal
      }) : null;
      {
        /* For sliding the composescreen over the ads modal */
      }
      var style = location.pathname.indexOf('compose') >= 0 ? {
        zIndex: 105
      } : {};
      var titleTemplate = "%s | ".concat(this.props.theme.businessName);
      return /*#__PURE__*/React.createElement(MuiThemeProvider, {
        muiTheme: getTheme(this.props.theme)
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.app
      }, /*#__PURE__*/React.createElement(AppRootErrorBoundary, null, /*#__PURE__*/React.createElement(ReactCSSTransitionGroup, {
        component: "div",
        transitionAppear: true,
        transitionAppearTimeout: 1000,
        transitionName: "slidein",
        transitionEnterTimeout: 1000,
        transitionLeaveTimeout: 1000
      }, isModal && /*#__PURE__*/React.createElement(ModalLayout, {
        style: style
      }, clonedChildren)), /*#__PURE__*/React.createElement(Helmet, _extends({}, config.app.head, {
        titleTemplate: titleTemplate
      })), /*#__PURE__*/React.createElement(MainLayout, {
        user: user
      }, !isModal ? clonedChildren : this.previousChildren))));
    }
  }]);

  return App;
}(Component), _defineProperty(_class2, "propTypes", {
  children: PropTypes.object.isRequired,
  user: PropTypes.object,
  logout: PropTypes.func.isRequired,
  pushState: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired
}), _temp)) || _class);
export { App as default };
/*
This is a component that will render when an exception is thrown
down the tree. If this "root" boundary is rendered, that means a really bad thing has happened
*/

var AppRootErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(AppRootErrorBoundary, _React$Component);

  var _super = _createSuper(AppRootErrorBoundary);

  function AppRootErrorBoundary(props) {
    var _this;

    _classCallCheck(this, AppRootErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  _createClass(AppRootErrorBoundary, [{
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            position: 'absolute',
            left: 0,
            top: 0,
            bottom: 0,
            right: 0,
            background: '#F9F9FA',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif'
          }
        }, /*#__PURE__*/React.createElement("h1", {
          style: {
            fontSize: 100
          }
        }, "\uD83E\uDD14"), /*#__PURE__*/React.createElement("h1", null, "Something didn't work right."), /*#__PURE__*/React.createElement("p", {
          style: {
            textAlign: 'center'
          }
        }, "We ran into a snag. But don't worry, we will be back online soon.", /*#__PURE__*/React.createElement("br", null), "Please check back in later."));
      }

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ToastContainer, null), this.props.children);
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      console.error('Caught Error at AppRootErrorBoundary', error);
      return {
        hasError: true
      };
    }
  }]);

  return AppRootErrorBoundary;
}(React.Component);